import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useT } from '../i18n/I18nContext';
import config from '../config/config';
import './Auth.css';

const Register = () => {
  const { t } = useT();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [serverUrl, setServerUrl] = useState(localStorage.getItem('serverUrl') || config.defaultServerUrl);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { register, loading, error } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');

    if (!email || !password || !confirmPassword) {
      setErrorMessage(t('register.fillAll'));
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage(t('register.passwordsMatch'));
      return;
    }

    if (!serverUrl) {
      setErrorMessage(t('register.enterServer'));
      return;
    }

    const success = await register(email, password, serverUrl);
    if (success) {
      navigate('/login', { state: { message: t('register.success') } });
    }
  };

  return (
    <div className="auth-page page-shell">
      <div className="container">
        <div className="auth-shell">
          <section className="auth-intro">
            <span className="section-eyebrow">{t('register.eyebrow')}</span>
            <h1>{t('register.heading')}</h1>
            <p>
              {t('register.body')}
            </p>
            <div className="auth-benefits">
              <div className="auth-benefit-card">
                <strong>{t('register.benefit1Heading')}</strong>
                <span>{t('register.benefit1Body')}</span>
              </div>
              <div className="auth-benefit-card">
                <strong>{t('register.benefit2Heading')}</strong>
                <span>{t('register.benefit2Body')}</span>
              </div>
            </div>
          </section>

          <section className="auth-form-panel">
            <div className="auth-form">
              <div className="auth-form-header">
                <h2>{t('register.formHeading')}</h2>
                <p>{t('register.formBody')}</p>
              </div>

              {(error || errorMessage) && (
                <div className="alert alert-danger">
                  {errorMessage || error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">{t('register.email')}</label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">{t('register.password')}</label>
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="confirm-password">{t('register.confirmPassword')}</label>
                  <input
                    type="password"
                    id="confirm-password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(event) => setConfirmPassword(event.target.value)}
                    required
                  />
                </div>

                {config.features.collapsibleServerUrl ? (
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn-link advanced-toggle"
                      onClick={() => setShowAdvanced(current => !current)}
                    >
                      {showAdvanced ? t('register.advancedHide') : t('register.advancedShow')} advanced settings
                    </button>

                    {showAdvanced && (
                      <div className="advanced-settings">
                        <label htmlFor="server-url">{t('register.serverURL')}</label>
                        <input
                          type="url"
                          id="server-url"
                          className="form-control"
                          value={serverUrl}
                          onChange={(event) => setServerUrl(event.target.value)}
                          placeholder={config.defaultServerUrl}
                          required
                        />
                        <small className="form-text">{t('register.serverHelp')}</small>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="form-group">
                    <label htmlFor="server-url">{t('register.serverURL')}</label>
                    <input
                      type="url"
                      id="server-url"
                      className="form-control"
                      value={serverUrl}
                      onChange={(event) => setServerUrl(event.target.value)}
                      placeholder={config.defaultServerUrl}
                      required
                    />
                    <small className="form-text">{t('register.serverHelp')}</small>
                  </div>
                )}

                <div className="form-actions">
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? t('register.loading') : t('register.btn')}
                  </button>
                  <Link to="/login" className="auth-link">
                    {t('register.hasAccount')}
                  </Link>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Register;
